/* globals alert, console, module, require */
/* jshint esversion: 6 */
/* jshint globalstrict: true */
'use strict';


// @acavan! - this should probably be unitVacancies.js

/*
  {
    "id": 1,
    "unitId": 2,
    "availableDate": "2019-11-26T00:00:00.000Z",
    "vacancyStatusTypeId": 1,
    "vacancyFillReasonTypeId": null
  },
*/

const Backbone = require('backbone'),
    BackboneRadio = require('backbone.radio'),
    _ = require('lodash'),
    //
    Vacancy = require('../models/vacancy'),
    configuration = require('../utilities/configuration'),
    formProcessor = require('../utilities/formProcessor').processor,
    templates = require('../utilities/handlebars').templates,
    user = require('../models/user'),
    columns = {
        availableDateFormatted: {
            type: 'text',
            display: 'Available'
        },
        vacancyStatus: {
            type: 'text',
            display: 'Status'
        },
        edit: {
            type: 'text',
            display: ''
        }
    },
    url = configuration.mockdata.unitVacancies ? '/mockdata/unitVacancies.json'  : configuration.apiUrlBase + 'unitVacancies/',
    EOL = null;

module.exports = Backbone.Collection.extend({
    channels: {
        console: BackboneRadio.channel('console')
    },
    model: Vacancy,
    columns: function (raw) {
        let a = [];
        a = _.map(columns, function (column, key) {
            var o = {
                name: key,
                display: column.display,
                src: column.src,
                alt: column.alt
            };
            o[column.type] = true;
            return o;
        });
        return a;
    },
    create: function (processedValues) {
        let vacancy,
            availableDate;
        processedValues.unitId = this.unitId;
        try {
            availableDate = new Date(processedValues.availableDate).toISOString();
        } catch (error) {
            availableDate = new Date(0).toISOString(); // default to "1970-01-01T00:00:00.000Z" if any problems...
        }
        if (processedValues.id === 0) {
            delete processedValues.id;
        }
        processedValues.availableDate = availableDate;
        vacancy = new Vacancy(processedValues);
        vacancy.save(null, {
            success: _.bind(function (model, response, options) {
                this.add(model);
            }, this),
            error: function (model, xhr, options) {
                const msg = 'Unable to create vacancy\n(' + xhr.responseJSON.message + ')';
                console.log(msg);
                alert(msg);
            }
        });
    },
    initialize: function (items, options) {
        this.unitId = options.unitId;
        this.hasAdminAccess = options.hasAdminAccess;
        this.reload();
    },
    reload: function () {
        if (this.unitId) {  // JJE: can be called too early. Wait for further events on the model.
            this.fetch({
                headers: user.authorizationHeader('vacancies'),
                method: 'GET',
                reset: true,
                url: url + (configuration.mockdata.unitVacancies ? '' : this.unitId)
            });
        }
    },
    rows: function () {
        let a = [],
            properties = _.keys(columns);
        a.push({
            context: 'edit',
            colspan: 4,
            edit: true,
            hidden: false,
            values: {
                form: templates.vacancyEdit({
                    create: true,
                    saveEnabled: true,
                    vacancyStatusTypeId: 2
                    // vacancyFillReasonTypeId: null
                })
            }
        });
        if (this.length) {
            _.each(this.models, _.bind(function (model) {
                const json = model.toJSON(),
                    display = {
                        id: json.id,
                        context: 'display',
                        display: true,
                        values: {}
                    },
                    edit = {
                        id: json.id,
                        context: 'edit',
                        edit: true,
                        colspan: 4,
                        hidden: true,
                        values: {}
                    };
                json.edit = this.hasAdminAccess ? templates.tableEditButton(_.invert({true: configuration.tableEditButtonStyle})) : '';
                _.each(properties, function (property) {
                    display.values[property] = json[property];
                });
                a.push(display);
                edit.values = {
                    form: templates.vacancyEdit(json)
                };
                a.push(edit);
            }, this));
        }
        return a;
    },
    save: function (serializedValues) {
        const processedValues = formProcessor(serializedValues, 'vacancies');
        if (processedValues.id) {
            this.update(processedValues);
        } else {
            this.create(processedValues);
        }
    },
    sortAttribute: function (attributeOrder) {
        let isAscending;
        if (attributeOrder) {
            isAscending = attributeOrder.order === 'ascending';
            this.attributeOrder = attributeOrder;
            this.reset(_.orderBy(
                this.models,
                function (model) {
                    let value = model.get(attributeOrder.attribute);
                    value = value === 0 ? '0' : value;
                    return value || (isAscending ? '_' : ' '); // force empty values to the end of the sort
                },
                isAscending ? 'asc' : 'desc'
            ));
        }
        return this.attributeOrder;
    },
    update: function (processedValues) {
        const model = this.get(processedValues.id);
        if (model) {
            model.set(processedValues);
            model.save();
        } else {
            alert('vacancies - cannot find model w/id:' + processedValues.id);
        }
    }
    // @acavan? 20191003_1452
    // states: function () {
    //     let a = [];
    //     if (this.length) {
    //         a = _.map(this.models, function (model) {
    //             return model.attributes.state;
    //         });
    //     }
    //     return _.uniq(a).sort();
    // }
});
